// Minimal shape needed to compute the skip key — accepts both the mapped
// CmsBaseComponent union and PageContent's CmsComponentProps.
type SkippableComponent =
  | { __typename?: string | null; id?: string | null }
  | null
  | undefined;

/**
 * Skip-check identity for a rendered CMS block. Strapi component ids are
 * unique only WITHIN a component type — the same numeric id is reused across
 * different `__typename`s (e.g. a `TrustStripComponent` and a
 * `ComponentPagesComponentBenefitComparisonTableComponent` can both have
 * `id: 2` on the same page). Matching a skip list on id alone can therefore
 * drop the wrong block as collateral damage.
 *
 * The (typename, id) pair is the true identity, and it is already the same
 * pair BlockMapper publishes in its rendered DOM via the
 * `data-block-type` / `data-block-id` attributes — this helper just mirrors
 * that pair into a single comparable key.
 */
export const getBlockSkipKey = (component: SkippableComponent): string =>
  `${component?.__typename ?? ''}:${component?.id ?? ''}`;
